import type { JSX } from 'react'

export const DiscoveryIcon = ({
  filled,
}: {
  filled?: boolean
}): JSX.Element => (
  <>
    <use
      href='#discoveryIcon'
      height='100%'
      width='100%'
      fillOpacity={!filled ? 1 : 0}
    />
    <use
      href='#discoverySolidIcon'
      height='100%'
      width='100%'
      fillOpacity={filled ? 1 : 0}
    />
  </>
)
